import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.subproducts;

export default class Subproducts extends Model {
  static entity = `${name}`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/subproducts',
    },
  };
}
